import React from 'react';
import {Modal} from "antd";
import ImgClose from "@/shared/pictures/close.svg";
import ImgGift from "@/shared/pictures/pucks_team.png";
import {useStore} from "@/app/providers/StoreProvider";
import {ModalPayload} from "@/entities/modals/types";
import {IQuestItemType} from "@/entities/quest/types";


export const QuestDailyModal = (payload: ModalPayload<"questDaily">) => {
    const { modalStore, questsStore, errorStore } = useStore();

    const getGift = async () =>{

        const check = await questsStore.checkQuests({questNameEnum:payload.id,secret:''});
        await questsStore.getQuests();
        modalStore.open('questCompleted',{});
    }

    return (
        <Modal
            open={true}
            footer={null}
            closeIcon={<img src={ImgClose} onClick={() => modalStore.close()} alt=""/>}
        >
            <div className='modal'>

                <img src={ImgGift} className='modal_image'
                     alt="" style={{maxWidth: 150}}/>

                <p className='modal_text'>Вам доступен ежедневный бонус, дополнительная попытка забить гол</p>

                <div className='modal_buttons'>
                    <button type='button' className='modal_button button_blue' onClick={() => getGift()}>Забрать</button>

                    <button type='button' className='modal_button button_gray'
                            onClick={() => modalStore.close()}>Закрыть
                    </button>
                </div>

            </div>
        </Modal>
    );
};

